/**
 * @flow
 */

import { SLOT_BOOKING_SUCCESS_RESPONSE_MODAL_Z_INDEX } from '../../../themes/Metrics'

const styles = {
  overlay: {
    position: 'none',
    backgroundColor: 'none'
  },
  content: {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    margin: 'auto',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'none',
    border: 'none',
    padding: 0,
    zIndex: SLOT_BOOKING_SUCCESS_RESPONSE_MODAL_Z_INDEX,
    position: 'fixed'
  }
}

export default styles



// WEBPACK FOOTER //
// ./src/components/IbcArcade/BookingResponseMessage/styles.js